import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GET_CITIES_URL,
  LOCATION_LIST_URL,
  STATE_LIST_URL,
  WARDS_LIST_URL,
  ZONE_LIST_URL,
} from "../../Services/endpoints";
import { errorHandler } from "../../Utils/toast";
import { _get } from "../../Services/baseApi";

const commonSlice = createSlice({
  name: "common",
  initialState: {
    cityList: [],
    stateList: [],
    locationList: [],
    zoneListOptions: [],
    wardListOptions: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCitiesForOptions.fulfilled, (state, action) => {
      state.cityList = action.payload;
    });

    builder.addCase(getStateForOptions.fulfilled, (state, action) => {
      state.stateList = action.payload;
    });

    builder.addCase(getLocationForOptions.fulfilled, (state, action) => {
      state.locationList = action.payload;
    });

    builder.addCase(getZoneForOptions.fulfilled, (state, action) => {
      state.zoneListOptions = action.payload;
    });

    builder.addCase(getWardForOptions.fulfilled, (state, action) => {
      state.wardListOptions = action.payload;
    });
  },
});

export default commonSlice.reducer;

export const getCitiesForOptions = createAsyncThunk(
  "commonSlice/getCitiesForOptions",
  async () => {
    try {
      const response = await _get(GET_CITIES_URL);
      return response?.data?.result.findCities || [];
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const getStateForOptions = createAsyncThunk(
  "commonSlice/getStateForOptions",
  async () => {
    try {
      const response = await _get(STATE_LIST_URL);
      return response?.data?.result.data;
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const getLocationForOptions = createAsyncThunk(
  "commonSlice/getLocationForOptions",
  async (params = {}) => {
    try {
      const response = await _get(LOCATION_LIST_URL, {
        page: params.page || 1,
        limit: params.limit || 20,
        key: "name",
        keyOrder: "ASC",
        ...params,
        lean: true,
      });
      return response?.data?.result.findLocations || [];
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const getZoneForOptions = createAsyncThunk(
  "commonSlice/getZoneForOptions",
  async () => {
    try {
      const response = await _get(ZONE_LIST_URL);
      return response?.data?.result.findZones || [];
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const getWardForOptions = createAsyncThunk(
  "commonSlice/getWardForOptions",
  async (zoneId) => {
    try {
      const response = await _get(WARDS_LIST_URL, {
        zoneId: zoneId || undefined,
        limit: 500,
      });
      return response?.data?.result.findWards || [];
    } catch (error) {
      errorHandler(error);
    }
  }
);
